export type Validation<T> = ({ data }: { data: any }) => (_?: T) => string | undefined;

export const isNotNull = <T>(_: T | null): _ is T    => _ !== null;
export const isNull    = <T>(_: T | null): _ is null => _ === null;

export const isDefined   = <T>(_?: T): _ is T         => _ !== undefined;
export const isUndefined = <T>(_?: T): _ is undefined => _ === undefined;

export type Emptiable = string | Record<string, any> | ArrayLike<any>;

export const isString = (_: any): _ is string              => typeof _ === "string";
export const isObject = (_: any): _ is Record<string, any> => typeof _ === "object";
export const isArray  = (_: any): _ is ArrayLike<any>      => typeof _ === 'object'
  && "length"        in _ && typeof _['length'       ] === 'number'
  && Symbol.iterator in _ && typeof _[Symbol.iterator] === 'function';

export const isEmptiable = (_: any): _ is Emptiable => isString(_) || isObject(_) || isArray(_) ;

export const isEmptyString = (_: string             ) => _ === "";
export const isEmptyObject = (_: Record<string, any>) => Object.keys(_).length === 0;
export const isEmptyArray  = (_: ArrayLike<any>     ) => _.length === 0;

export const isEmpty = (_: Emptiable) => (
  isString(_) ? isEmptyString(_) :
  isObject(_) ? isEmptyObject(_) :
  isArray (_) ? isEmptyArray (_) : false
);
export const isNotEmpty = (_: Emptiable) => !isEmpty(_);

export const isPresent  = (_: any) => isDefined(_) && (!isEmptiable(_) || isNotEmpty(_));
export const isAbsent   = (_: any) => isUndefined(_) || (isEmptiable(_) && isEmpty(_));

// export const isText         = (_?: string) => isDefined(_) && typeof _ === "string";
// export const isTrimmed      = (_?: string) => isDefined(_) && isText(_) && _!.trim() === _;
// export const isStandardText = (_?: string) => isDefined(_) && isText(_) && isNotEmpty(_) && isTrimmed(_);

// export const isNumber        = (_?: string) => isDefined(_) && /^[0-9,]{1,15}(?:\.[0-9]{1,})?$/.test(_);
// export const isInt           = (_?: string) => isDefined(_) && /^[0-9,]{1,15}$/.test(_);
// export const isDecimal         = (fractionDigits: number) => (_?: string) => isDefined(_) && new RegExp(`^[0-9,]{1,15}(?:\\.[0-9]{1,${fractionDigits}})?$`).test(_!);
// export const isMoney         = (_?: string) => isDefined(_) && /^\$?[0-9,]{1,15}(?:\.[0-9]{1,2})?$/.test(_);

// export const isDate  = (_?: string) => isPresent(_) && editable_IS.dateOnly(editable(_)) === undefined;
